export default {
  CARD: 'card'
};


/** WEBPACK FOOTER **
 ** ./examples/04 Sortable/Simple/ItemTypes.js
 **/